import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  Button,
  Grid,
  TextField,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import styles from "./DealerShipDetails.module.scss";
import crStyles from "../../customerReservation/crStyles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Clear from "@mui/icons-material/Clear";
import EditIcon from "../../../shared/Edit/EditIcon";
import { withTranslation } from "react-i18next";
import DealerEmployeeTable from "./DealerEmployeeTable";
import HasPermissionTo from "../../../common/HasPermissionTo";
import DealerDetailsClient from "../../../shared/clients/DealerDetailsClient";

const StyledAccordionSummary = styled(AccordionSummary)({
  "& .MuiAccordionSummary-content": {
    margin: 0,
    "&.Mui-expanded": {
      margin: 0,
    },
  },
  "&.Mui-expanded": {
    margin: 0,
  },
});

const DealerContactInfo = (props) => {
  const [expand, setExpand] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [currentEmailText, setCurrentEmailText] = useState(
    props.dealers.emailAddress
  );
  const [currentPhoneText, setCurrentPhoneText] = useState(
    props.dealers.phoneNumber
  );
  const [emailText, setEmailText] = useState(props.dealers.emailAddress);
  const [phoneText, setPhoneText] = useState(props.dealers.phoneNumber);
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const dealer = props.dealers;
  const showAddress = props.user.permissions.rolePermissions.hasOwnProperty(
    "businessAddress:view"
  );

  const flipIcon = () => {
    setExpand((prev) => !prev);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      return props.t("Error.requiredField");
    }
    if (!emailRegex.test(email)) {
      return props.t("Error.invalidInput");
    }
    return "";
  };

  const validatePhone = (phone) => {
    if (!phone) {
      return props.t("Error.requiredField");
    }
    return "";
  };

  const cancelEdit = () => {
    setEditMode(false);
    setEmailText(currentEmailText);
    setPhoneText(currentPhoneText);
    setEmailError("");
    setPhoneError("");
  };

  const updateEmailAndPhone = (completeDealerId) => {
    const emailValue = emailText;
    const phoneValue = phoneText;

    const emailErr = validateEmail(emailValue);
    const phoneErr = validatePhone(phoneValue);

    if (emailErr || phoneErr) {
      setEmailError(emailErr);
      setPhoneError(phoneErr);
      return;
    }

    DealerDetailsClient.updateDealerEmailAddress(
      props.user,
      completeDealerId,
      emailValue
    )
      .then(() => {
        setCurrentEmailText(emailValue);
        return updatePhone(completeDealerId, emailValue, phoneValue);
      })
      .catch(() => {});
  };

  const updatePhone = (completeDealerId, emailIdValue, phoneValue) => {
    return DealerDetailsClient.updateDealerPhoneNumber(
      props.user,
      completeDealerId,
      phoneValue
    )
      .then((dealer) => {
        setPhoneText(phoneValue);
        setCurrentPhoneText(phoneValue);
        setEditMode(false);
        setEmailError("");
        setPhoneError("");
        props.updateDealerPhoneAndEmail(dealer, emailIdValue, phoneValue);
      })
      .catch(() => {});
  };

  const editDealershipInfo = () => {
    setEditMode(true);
  };

  const emailOnChange = (event) => {
    setEmailText(event.target.value);
    if (emailError) setEmailError("");
  };

  const phoneOnChange = (event) => {
    setPhoneText(event.target.value);
    if (phoneError) setPhoneError("");
  };

  const dealerId = dealer.dealerId;

  return (
    <div className={styles.divPadding}>
      <Accordion
        classes={{ root: styles.expPanelNoBoxShadow }}
        style={{ marginBottom: "10px" }}
        defaultExpanded={true}
        onChange={flipIcon}
      >
        <StyledAccordionSummary style={crStyles.headerBarBg} id="exp">
          <div className={styles.headerBar}>
            <div>
              {dealer.name}
              <span>({dealerId})</span>
            </div>
            {expand ? (
              <ExpandLessIcon id="less" />
            ) : (
              <ExpandMoreIcon id="more" />
            )}
          </div>
          <br />
        </StyledAccordionSummary>
        <div className={styles.businessDetailsContainer}>
          <div className={styles.sectionHeaderDealership}>
            {props.t("DealerShipDetails.dealershipHeader")}
          </div>
          <div className={styles.subHeader}>
            <HasPermissionTo
              perform={["businessAddress:view"]}
              permissions={props.user.permissions.rolePermissions}
              render={() => (
                <span
                  id="businessDetails"
                  className={styles.businessDetailsInputGridModel}
                >
                  {props.t("DealerShipDetails.businessDetails")}
                </span>
              )}
            />
          </div>
          <form
            style={{ width: "100%" }}
            onSubmit={(e) => {
              e.preventDefault();
              updateEmailAndPhone(dealer.completeDealerId);
            }}
          >
            <Grid container className={!showAddress ? styles.addressFlex : ""}>
              <HasPermissionTo
                perform={["businessAddress:view"]}
                permissions={props.user.permissions.rolePermissions}
                render={() =>
                  props.user.market.toUpperCase() === "DEU" ? (
                    <Grid item md={3} className={styles.divAddress}>
                      <span>{dealer.address.street} </span>
                      <span>
                        {dealer.address.postalCode}&nbsp;
                        {dealer.address.city}
                      </span>
                      <span> {dealer.address.country}</span>
                    </Grid>
                  ) : (
                    <Grid item md={3} className={styles.divAddress}>
                      <span>{dealer.address.street} </span>
                      <span> {dealer.address.city}</span>
                      <span>
                        {" "}
                        {dealer.address.country},{dealer.address.postalCode}
                      </span>
                    </Grid>
                  )
                }
              />
              {editMode ? (
                <Grid item md={3} className={styles.divEmail}>
                  <TextField
                    value={emailText}
                    onChange={emailOnChange}
                    variant="outlined"
                    style={{ width: "70%" }}
                    name={`emailInput_${dealer.completeDealerId}`}
                    id={`emailInput_${dealer.completeDealerId}`}
                    error={!!emailError}
                    helperText={emailError}
                  />
                </Grid>
              ) : (
                <Grid item md={3} className={styles.divEmail}>
                  {emailText ? (
                    <span className={styles.emailText}>{emailText}</span>
                  ) : (
                    props.t("DealerShipDetails.emailAddress")
                  )}
                </Grid>
              )}
              {editMode ? (
                <Grid
                  item
                  md={3}
                  className={`${styles.divPhone} editPhoneReady`}
                >
                  <TextField
                    variant="outlined"
                    style={{ width: "60%" }}
                    onChange={phoneOnChange}
                    value={phoneText}
                    name={`phoneInput_${dealer.completeDealerId}`}
                    id={`phoneInput_${dealer.completeDealerId}`}
                    error={!!phoneError}
                    helperText={phoneError}
                  />
                </Grid>
              ) : (
                <Grid item md={3} className={`${styles.divPhone} editPhoneOn`}>
                  {phoneText ? (
                    <span className={styles.phoneText}>{phoneText}</span>
                  ) : (
                    props.t("DealerShipDetails.phoneNumber")
                  )}
                </Grid>
              )}
              <Grid
                item
                md={3}
                className={
                  showAddress
                    ? styles.contactEditDiv
                    : styles.contactEditDivNoAddress
                }
              >
                {editMode ? (
                  <>
                    <Button id={`confirmInfo_${dealerId}`} type="submit">
                      <div className={styles.confirm}>OK</div>
                    </Button>
                    <Button id={`cancelInfo_${dealerId}`} onClick={cancelEdit}>
                      <Clear />
                    </Button>
                  </>
                ) : (
                  <HasPermissionTo
                    perform={["dealershipDetails:write"]}
                    permissions={props.user.permissions.rolePermissions}
                    condition={!props.isMainViewingSDLR(props.dealers)}
                    render={() => (
                      <Button
                        id={`Edit_${dealerId}`}
                        onClick={editDealershipInfo}
                      >
                        <EditIcon />
                      </Button>
                    )}
                  />
                )}
              </Grid>
            </Grid>
          </form>
        </div>
        <DealerEmployeeTable {...props} />
      </Accordion>
    </div>
  );
};

export default withTranslation("emp")(DealerContactInfo);
